import React, { useState, useEffect } from 'react'

import { trackPromise } from 'react-promise-tracker'

import DocumentDisplay from '../../../../components/DocumentDisplay'
import { GetInsightUnderstandingDocuments } from '../../../../store/ContentfulClient'
import LoadingWrapper from '../../../../components/LoadingWrapper'

const Understanding = () => {
    const UnderstandingPromiseArea = 'understanding-list'
    // const { user } = useAuth0()
    const [documents, setDocuments] = useState([])

    useEffect(() => {
        const SetDocuments = () => {
            setDocuments([])
            trackPromise(
                GetInsightUnderstandingDocuments().then((documents) => {
                    setDocuments(documents)
                }),
                UnderstandingPromiseArea
            )
        }

        SetDocuments()
    }, [])

    return (
        <>
            <LoadingWrapper area={UnderstandingPromiseArea}>
                <DocumentDisplay documents={documents} />
            </LoadingWrapper>
        </>
    )
}

export default Understanding
